import { createSelector } from '@reduxjs/toolkit';

import { selectPageType } from 'src/redux/navigation';
import { PageType } from 'src/types';

export const selectReferredBy = createSelector(selectPageType, (pageType) => {
  switch (pageType) {
    case PageType.Category:
    case PageType.AllProducts:
      return 'plp';
    case PageType.Search:
      return 'search';
    case PageType.Partner:
      return 'pplp';
    default:
      return undefined;
  }
});
